<template>
  <div id="calendar">
    <div class="calendar-header">
      <div class="datepicker-wrapper">
        <datepicker
          :value="selectedDate"
          :format="format"
          :language="ee"
          v-model="selectedDate"
          :monday-first="true"
          :disabled-dates="disabledDates"
        ></datepicker>
        <div class="today" v-on:click="setToday">{{ $t('Today') }}</div>
      </div>
      <ul>
        <li v-on:click="getCourtData('getCourtDefinitionsInside', selectedDate)">{{ $t('Courts inside') }}</li>
        <li v-on:click="getCourtData('getCourtDefinitionsOutside', selectedDate)">{{ $t('Courts outside') }}</li>
        <li v-on:click="getCourtData('getCourtDefinitionsPadel', selectedDate)" v-show="false" class="court-padel">
          {{ $t('Padel courts') }}
        </li>
        <li v-on:click="plansVisible = true" class="showplans">{{ $t('View court plans') }}</li>
      </ul>
    </div>
    <div class="courts">
      <ReservationForm v-bind:reservationData="reservationData" v-show="reservationData.reservationFormVisible"/>
      <RequireLoginForm v-bind:reservationData="reservationData" v-show="reservationData.requireLoginFormVisible"/>
      <div v-if="enabledFromDate > selectedDate" class="closed-text">
        Valitud kuupäeval on Tennisekeskus suletud.
      </div>
      <div v-show="enabledFromDate < selectedDate">
        <table id="timeselect" :class="{'safari' : isSafari() == true}">
          <thead>
          <tr>
            <th></th>
            <th v-for="court in courtsData" :key="court">{{ court }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(slot, index) in times" :key="slot" class="line" v-if="index != times.length - 1">
            <td class="time">{{ slot }}</td>
            <td v-for="(court, index) in courtsData" :key="index" v-on:click="reserveTime()"
                :class="'select-slot ' + removeSpace(court)" :data-court="court" :data-time="slot"
                :data-disabled="false">{{ slot }}
            </td>
          </tr>
          </tbody>
        </table>
        <div class="legend">
          <ul>
            <li class="legend-tennis">{{ $t('selected time') }}</li>
            <li class="legend-padel">{{ $t('selected time') }}</li>
            <li class="legend-free">{{ $t('free time') }}</li>
          </ul>
        </div>
      </div>
    </div>
    <Plans v-bind:plansVisible="plansVisible"/>
  </div>
</template>

<script>
import axios from 'axios';
import ReservationForm from '../../views/calendar/ReservationForm.vue';
import RequireLoginForm from '../../views/calendar/RequireLoginForm.vue';
import Plans from '../../views/calendar/Plans.vue';
import Datepicker from 'vuejs-datepicker';
import {en, ee} from 'vuejs-datepicker/dist/locale';
import calendarHelper from '../../helpers/calendar.js';

export default {
  components: {
    Datepicker,
    RequireLoginForm,
    ReservationForm,
    Plans
  },
  created() {
    if (this.$store.getters.isLoggedIn) {
      this.getClientAccountData();
    }
  },
  data() {
    var state = {
      date: new Date()
    }
    return {
      clientData: [],
      activeCourtRequest: 'getCourtDefinitionsInside',
      reservedTimes: false,
      courtOpenTime: false,
      courtCloseTime: false,
      selectedDate: state.date,
      courtsData: this.getCourtData('getCourtDefinitionsInside', this.selectedDate),
      format: "dd.MM.yyyy",
      ee: ee,
      en: en,
      times: false,
      reservationData: [
        {'reservationFormVisible': false},
        {'requireLoginFormVisible': false}
      ],
      plansVisible: false,
      errors: false,
      disabledDates: {
        to: this.addDays(-1), // Disable all dates up to specific date
        from: this.addDays(6) // Disable all dates after specific date
      },
      enabledFromDate: new Date('March 23 2020')
    }
  },
  methods: {
    addDays: function (days) {
      var date = new Date();
      date.setDate(date.getDate() + days);
      return date;
    },
    getCourtData: function (apiRequestName, date) {
      this.activeCourtRequest = apiRequestName;
      var courtMapping = new Map();
      courtMapping.set('getCourtDefinitionsInside', 'getCourtBookingsInside');
      courtMapping.set('getCourtDefinitionsOutside', 'getCourtBookingsOutside');
      courtMapping.set('getCourtDefinitionsPadel', 'getCourtBookingsPadel');
      var courtDate = (date !== undefined) ? date : new Date();
      courtDate = courtDate.toISOString().slice(0, 10);
      axios.get('/' + apiRequestName + '?date=' + courtDate)
        .then(response => {
          if (apiRequestName === 'getCourtDefinitionsPadel') {
            document.getElementById("logo").style.display = "none";
            document.getElementById("logo-padel").style.display = "block";
            document.getElementById('timeselect').classList.add('padel');
          } else {
            document.getElementById("logo").style.display = "block";
            document.getElementById("logo-padel").style.display = "none";
            document.getElementById('timeselect').classList.remove('padel');
          }
          this.courtsData = response.data.data.definitions;
          this.courtOpenTime = response.data.data.open;
          this.courtCloseTime = response.data.data.end;
          this.times = this.getEachHalfHour(this.courtOpenTime, this.courtCloseTime);
          this.getReservedTimes(courtMapping.get(apiRequestName));
        })
        .catch(e => {
          // console.log(e)
        });
    },
    getReservedTimes: function (apiRequestName) {
      let selectedtime = this.selectedDate.toISOString().slice(0, 10);
      axios.get('/' + apiRequestName + '?date=' + selectedtime)
        .then(response => {
          this.reservedTimes = response.data.data;
          this.fillTimes(selectedtime);
        })
        .catch(e => {
          //console.log(e);
          //this.errors.push(e)
        });
    },
    getEachHalfHour: function (startTime, endTime) {
      return calendarHelper.getEachHalfHour(startTime, endTime);
    },
    reserveTime: function () {
      let target = event.target;
      let time = target.getAttribute('data-time');
      let court_name = target.getAttribute('data-court');
      let isDisabled = target.getAttribute('data-disabled');
      if (isDisabled === 'true') {
        return;
      }
      let appElem = document.getElementById("app").getBoundingClientRect();
      this.reservationData.reservationFormVisible = false;
      if (!this.$store.getters.isLoggedIn) {
        this.reservationData = {
          'requireLoginFormVisible': true,
          'top': Math.abs(appElem.top) + 20 + 'px'
        }
      } else {
        var curDate = this.selectedDate.toISOString().slice(0, 10);
        var _this = this;
        var nextUntil = function (elem, selector) {
          var times = document.getElementsByClassName(selector);
          var lastenableTime = times[times.length - 1].getAttribute('data-time');
          for (var i = 0; i < times.length; i++) {
            if (parseDate(curDate + ' ' + times.item(i).getAttribute('data-time')) >= parseDate(curDate + ' ' + elem.getAttribute('data-time'))) {
              if (times.item(i).getAttribute('data-disabled') == 'true') {
                return times.item(i).getAttribute('data-time');
              } else if (times.item(i).getAttribute('data-time') == lastenableTime) {
                return _this.courtCloseTime;
              }
            }
          }
        }

        function parseDate(date) {
          const parsed = Date.parse(date);
          if (!isNaN(parsed)) {
            return parsed;
          }

          return Date.parse(date.replace(/-/g, '/').replace(/[a-z]+/gi, ' '));
        }

        var nextReservedTime = nextUntil(target, this.removeSpace(court_name));
        var durationTimes = this.getEachHalfHour(time, nextReservedTime);
        durationTimes.shift();

        this.reservationData = {
          'date': this.selectedDate,
          'starttime': time,
          'endtime': '',
          'courtname': court_name,
          'reservationFormVisible': true,
          'duration': durationTimes,
          'firstname': '',
          'lastname': '',
          'comment': '',
          'phone': '',
          'email': '',
          'top': Math.abs(appElem.top) + 20 + 'px'
        }
      }
    },
    setToday: function () {
      this.selectedDate = new Date();
    },
    closePlans: function (data) {
      this.plansVisible = false;
    },
    fillTimes: function () {
      return calendarHelper.fillTimes(this.reservedTimes, this.selectedDate);
    },
    removeSpace: function (str) {
      return str = str.replace(/\s+/g, '');
    },
    isSafari: function () {
      return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    },
    fieldEnabled: function (time) {
      time = Number(time.replace(':', ''))
      let currentDate = new Date()
      let hours = currentDate.getHours()
      let minutes = (currentDate.getMinutes() < 10 ? '0' : '') + currentDate.getMinutes()
      return Number(hours + minutes) > time
    },
    getClientAccountData: function () {
      if (this.$store.getters.isLoggedIn) {
        axios.get('/getClientAccountData')
          .then(response => {
            if (response.data.success) {
              this.clientData = response.data.data;
              if (this.clientData.activeSubscription !== null) {
                this.disabledDates = {
                  to: this.addDays(-1),
                  from: this.addDays(13)
                }
              }
            }
          })
          .catch(e => {
            if (e.response.status === 401) {
              localStorage.removeItem('token');
              this.$router.go(0)
            }
            //this.errors.push(e)
          });
      }
    },
  },
  watch: {
    selectedDate: function () {
      this.getCourtData(this.activeCourtRequest, this.selectedDate);
    }
  }
}
</script>

<style lang="scss" scoped>
#calendar {
  max-width: 1200px;
  margin: 0 auto;

  .calendar-header {
    padding: 40px 0 20px;
    float: left;
    width: 100%;

    > ul {
      float: right;
      padding: 0;

      li {
        &.court-padel {
          background: #CF587D;
        }

        display: inline-block;
        padding: 5px 20px;
        background: #4AA259;
        color: #fff;
        border: 0;
        font-size: 1rem;
        cursor: pointer;

        &:hover {
          opacity: 0.8;
        }

        &.showplans {
          background: #dedede;
          color: #111;
          margin-left: 10px;
          @media only screen and (max-width: 520px) {
            margin-top: 10px;
          }
        }

        @media only screen and (max-width: 520px) {
          &:nth-child(-n+3) {
            width: 32.5%;
          }

        }
        @media only screen and (max-width: 850px) {
          padding: 5px;
        }
      }

      @media only screen and (max-width: 715px) {
        padding-top: 20px;
        float: left;
        clear: both;
      }
    }
  }

  .datepicker-wrapper {
    .vdp-datepicker {
      float: left;
    }

    .today {
      float: left;
      margin-left: 10px;
      background: #dedede;
      line-height: 29px;
      padding: 0 20px;
      color: #111;
      cursor: pointer;
    }
  }

  .closed-text {
    clear: both;
    padding: 30px;
    margin-bottom: 60px;
    font-size: 1.4rem;
  }

  #timeselect {
    width: 100%;
    table-layout: fixed;

    tr {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
    }

    thead > tr {
      position: -webkit-sticky;
      position: -moz-sticky;
      position: -ms-sticky;
      position: -o-sticky;
      position: sticky;
      top: 0;
      background: #fafafa;
    }

    th {
      -ms-flex-preferred-size: 0;
      flex-basis: 0;
      -webkit-box-flex: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      @media only screen and (max-width: 576px) {
        font-size: 0.6rem;
      }
    }

    td {
      -ms-flex-preferred-size: 0;
      flex-basis: 0;
      -webkit-box-flex: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      max-width: 100%;
      border-right: 1px #fff solid;
      border-bottom: 1px #fff solid;
      transition: 250ms all;
      padding: 5px;
      background: #efefef;
      @media only screen and (max-width: 576px) {
        font-size: 3.3vw;
        padding: 0 2px;
        height: 36px;
        line-height: 36px;
        min-width: 20px;
      }

      &.time {
        width: 50px;
      }

      &.select-slot {
        background: #efefef;
        cursor: pointer;
        color: #111;

        &:hover {
          background: #d6d6d6;
          color: #111;
        }

        &.selected {
          background: #97DEB8;
          color: #888;
        }
      }
    }

    &.padel td {
      &.selected {
        background: #EBC5D4;
      }

    }

    &.safari {
      tr {
        display: table-row;
      }
    }
  }

  .legend {
    display: block;
    text-align: left;

    ul {
      padding: 0;
      margin-top: 20px;
    }

    li {
      line-height: 30px;
      margin-bottom: 5px;

      &:before {
        content: '';
        float: left;
        width: 30px;
        height: 30px;
        margin-right: 15px;
      }

      &.legend-tennis {
        &:before {
          background: #97DEB8;
        }
      }

      &.legend-padel {
        &:before {
          background: #EBC5D4;
        }
      }

      &.legend-free {
        &:before {
          background: #efefef;
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/calendar/Calendar.vue